module.exports = __webpack_public_path__ + "img/FAQ.da3d2165.svg";